(function(){
    angular
        .module('appback')
        .directive('ngGrupofelino', grupofelino);

        grupofelino.$inject = ['$timeout','GenerallabService'];
        function grupofelino($timeout,GenerallabService){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=grupofelino.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.generalLab = GenerallabService;
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { grupo : ""  }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { grupo : ""  }};
				            }else{
				            	if(!scope.item.resultado.extra.resultado){
				            		scope.item.resultado.extra.resultado = { grupo : ""  };
					            }else{
					            	if(Array.isArray(scope.item.resultado.extra.resultado)){
				            			scope.item.resultado.extra.resultado = { grupo : ""  };
					            	}
				       				//console.log("resmd");
				       				//console.log(scope.item.resultado.extra.resultado);

					            }
				            }
				        }
				        //console.log(scope.item.resultado.extra);

				        

			        });
		        }
          }
      }
})();